export default function FeatherSVG({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="#39e29d"
      width={21}
      height={21}
      viewBox="0 0 21 21"
    >
      <g>
        <path
          d="M44.955 23.2c-.851.389-2.317 1.271-3.539 1.894q-.839.429-1.718.781a23.453 23.453 0 0 0-7.037 4.451.566.566 0 0 0-.166.549l.25 1.018a.357.357 0 0 1-.1.345.362.362 0 0 1-.352.083l-.851-.252a.571.571 0 0 0-.6.183 17.834 17.834 0 0 0-3.755 7.757 1.672 1.672 0 0 1-.347.722l-2.03 2.458a.6.6 0 0 0 .084.819.608.608 0 0 0 .828-.03l2.356-2.2a105.562 105.562 0 0 1 9.006-10.683.463.463 0 0 1 .652-.014.457.457 0 0 1 .014.649c-.059.061-4.537 4.724-7.755 8.975a.327.327 0 0 0-.021.364.331.331 0 0 0 .329.16 14.517 14.517 0 0 0 5.954-2.186.566.566 0 0 0 .232-.654l-.5-1.476a.225.225 0 0 1 .056-.233.228.228 0 0 1 .236-.051l1.753.618a.571.571 0 0 0 .594-.135 15.51 15.51 0 0 0 1.777-2.153.563.563 0 0 0 .024-.6l-.8-1.385a.314.314 0 0 1 .012-.333.318.318 0 0 1 .306-.137l1.335.18a.567.567 0 0 0 .59-.32q.053-.113.1-.228l.015-.037c.1-.271 1.277-3.415 1.847-5.115a18.3 18.3 0 0 1 1.76-3.144.442.442 0 0 0-.539-.64z"
          transform="translate(-24.586 -23.156)"
        />
      </g>
    </svg>
  );
}
